import React,{ useState,useEffect, Fragment, useMemo } from 'react';
import ChangePasswordComponent from '../ChangePasswordComponent/ChangePasswordComponent';
import FullPageLoader from '../CommonPage/FullPageLoader';
import "../CommonPage/newStyles.scss"
import Popup from '../CommonPage/Popup.component';
import { useSelector, useDispatch } from "react-redux";
import { userActions } from "../../redux/actions/user.actions";

const PROFILE_SETTING_TABS = {
  LoginDetails: 'LoginDetails',
  MFA: 'MFA',
}

const MFA_TYPES = {
  google: 'google',
  email: 'email',
  sms: 'sms',
}

const ProfileSettingComponent = () => {
    const loggedUserInfo = useSelector((state) => state.loggedUserInfo);
    const changePassword= useSelector((state) => state.changePassword);
    const toggleMFA = useSelector((state) => state.toggleMFA);
    const MFAQR = useSelector((state) => state.generateMFAQR);
    // clearing popup data creating usestate for reducer.
    const [alertStatus, setAlertStatus] = useState(false);
    const [activeTab, setActiveTab] = useState(PROFILE_SETTING_TABS.LoginDetails);
    const [IsMFAEnabled, setIsMFAEnabled] = useState(loggedUserInfo?.items?.IsMFAEnable ?? false);
    const [MFAType, setMFAType] = useState('');

    const dispatch = useDispatch();
  useEffect(() => {
    dispatch(userActions.getLoggedUserInfo());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setMFAType(IsMFAEnabled ? MFA_TYPES.google : '');
  }, [IsMFAEnabled]);

    //change password popup call
    const [showChangePassword, setShowChangePassword] = useState(false);
    const handleChangePasswordClose = () => setShowChangePassword(false);
    const handleChangePasswordShow = () => {setChangePwd((changePwd) =>({...changePwd, oldPassword:"", passWord: "",confirmPassword:""}));setAlertStatus("");setShowChangePassword(true);}

  //loading spinner
  const [isChangePasswordLoaded, setIsChangePasswordLoaded] = useState(false);

  const [changePwd, setChangePwd] = useState({
    clientId:loggedUserInfo && loggedUserInfo.items && loggedUserInfo.items.ClientID,
    userId:loggedUserInfo && loggedUserInfo.items && loggedUserInfo.items.UserName,
    oldPassword: '',
    passWord: '',
    confirmPassword: '',
  });

  const handlePersonalDetailsChange = (e) => {
    const { name, value } = e.target;
    setChangePwd((changePwd) => ({ ...changePwd, [name]: value }));
  };

  const changePasswordHandleClick = (e) => {
    e.preventDefault();
    if( changePwd.passWord!==changePwd.confirmPassword) {
        return ;
    }
    dispatch(userActions.postChangePassword(changePwd.clientId,changePwd.userId, changePwd.oldPassword,
    changePwd.passWord,changePwd.confirmPassword));
    setAlertStatus(changePassword)

  }

  const handleChangeMFAEnable = () => {
    setIsMFAEnabled(!IsMFAEnabled);
  }

  const handleSubmitMFA = (event) => {
    event.preventDefault();

    const clientId = loggedUserInfo && loggedUserInfo.items && loggedUserInfo.items.ClientID;
    const userId = loggedUserInfo && loggedUserInfo.items && loggedUserInfo.items.UserName;

    dispatch(userActions.postToggleMFA(clientId, userId, IsMFAEnabled, MFAType));
  }

  useEffect(() => {
    setAlertStatus(changePassword)
    // eslint-disable-next-line
  }, [changePassword]);
  

  useEffect(() => {
    if (IsMFAEnabled) {
      dispatch(userActions.generateMFAQR());
    }
  }, [IsMFAEnabled]);

  const tabToDisplay = (tab) => {
    switch (tab) {
      case PROFILE_SETTING_TABS.LoginDetails:
        return (
          <Fragment>
            <h5  className="fw-bold"> Account Login Details</h5>
            <form>
              <table className="form-group fs-6">
                <tr>
                  <td>
                    <label htmlFor="name" className="col-form-label">
                      Name
                    </label>
                  </td>
                </tr>
                <tr>
                  <td>
                    <input
                      className="form-control fs-6 fw-normal"
                      type="text"
                      size="50"
                      name="name"
                      value={
                        loggedUserInfo &&
                        loggedUserInfo.items &&
                        loggedUserInfo.items.FullName
                      }
                      readOnly={true}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label htmlFor="userName" className="col-form-label">
                      Username
                    </label>
                  </td>
                </tr>
                <tr>
                  <td>
                    <input
                      className=" form-control fs-6 fw-normal"
                      type="text"
                      size="50"
                      name="userName"
                      readOnly={true}
                      value={
                        loggedUserInfo &&
                        loggedUserInfo.items &&
                        loggedUserInfo.items.UserName
                      }
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label htmlFor="email" className="col-form-label">
                      Email
                    </label>
                  </td>
                </tr>
                <tr>
                  <td>
                    <input
                      className=" form-control fs-6 fw-normal"
                      type="text"
                      size="50"
                      name="email"
                      readOnly={true}
                      value={
                        loggedUserInfo &&
                        loggedUserInfo.items &&
                        loggedUserInfo.items.EmailID
                      }
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label htmlFor="password" className="col-form-label">
                      Password
                    </label>
                  </td>
                </tr>
                <tr>
                  <td>
                    <input
                      type="button"
                      className="buttonCommon w-100"
                      value="Change password"
                      id="sendLink"
                      onClick={handleChangePasswordShow}
                    />
                    {showChangePassword && (
                      <Popup
                        show={showChangePassword}
                        handleClose={handleChangePasswordClose}
                        handleShow={handleChangePasswordShow}
                        body={
                          <ChangePasswordComponent
                            changePwd={changePwd}
                            alertStatus={alertStatus}
                            handlePersonDetailsChange={handlePersonalDetailsChange}
                          />
                        }
                        btnName="Save"
                        handleClick={changePasswordHandleClick}
                        isPopupReportLoading={isChangePasswordLoaded}
                      />
                    )}
                  </td>
                </tr>
                {isChangePasswordLoaded ? <FullPageLoader /> : null}
              </table>
            </form>
          </Fragment>
        )
        break;
      case PROFILE_SETTING_TABS.MFA:
        return (
          <form onSubmit={handleSubmitMFA} className="fs-6">
            <div style={{width: 'max-content'}}>
              <div class="form-check">
                <input class="form-check-input" name="IsMFAEnabled" type="checkbox" onChange={handleChangeMFAEnable} checked={IsMFAEnabled} />
                <label class="form-check-label" htmlFor="flexCheckDefault">
                  Enable Multi-factor Authentication
                </label>
              </div>
              {IsMFAEnabled && (
                <fieldset className="d-block mb-4" style={{ paddingLeft: '1rem' }}>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="MFAType" value="google" checked={MFAType === MFA_TYPES.google} />
                    <label class="form-check-label" htmlFor="MFAType">
                      Google
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="MFAType" value="email"  checked={MFAType === MFA_TYPES.email} />
                    <label class="form-check-label" htmlFor="MFAType">
                      Email
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="MFAType" value="sms"  checked={MFAType === MFA_TYPES.sms} />
                    <label class="form-check-label" htmlFor="MFAType">
                      SMS
                    </label>
                  </div>
                </fieldset>
              )}
              <button type="submit" className="buttonCommon w-100">Save changes</button>
            </div>
            {toggleMFA?.items?.IsSuccess && !!toggleMFA?.items?.Message && (
              <div class="alert alert-success mt-4" role="alert">
                {toggleMFA?.items?.Message}
              </div>
            )}
            {MFAQR?.items?.IsSuccess && !!MFAQR?.items?.DataObject?.BarcodeImageUrl && (
              <img src={MFAQR.items.DataObject.BarcodeImageUrl} alt='MFA QR' height={200} className="mt-4" />
            )}
          </form>
        )
        break;
    }
  }

    return (
        <div className="container  ">
        <h4 className="panel-title ">Profile Settings</h4>
          <ul class="nav nav-tabs mb-4">
            <li class="nav-item">
              <a class={`nav-link ${activeTab === PROFILE_SETTING_TABS.LoginDetails ? 'active' : ''}`} onClick={() => setActiveTab(PROFILE_SETTING_TABS.LoginDetails)}>Login Details</a>
            </li>
            <li class="nav-item">
              <a class={`nav-link ${activeTab === PROFILE_SETTING_TABS.MFA ? 'active' : ''}`} onClick={() => setActiveTab(PROFILE_SETTING_TABS.MFA)}>MFA</a>
            </li>
          </ul>
          {tabToDisplay(activeTab)}
        </div>
    );
};

export default ProfileSettingComponent;